
export enum ApiContractImplApiMethodCd {
	DELETE = 'DELETE',
	GET = 'GET',
	POST = 'POST',
	PUT = 'PUT'}

